import * as t from "io-ts";
import nullable from "./nullable";
import optional from "./optional";
import { cargoTypeT } from "./types";
import { withFallback } from "io-ts-types";
export const createCargoViewTypes = ({ decimal, dateTime, }) => {
    const cargoViewStopT = t.strict({
        id: nullable(t.string),
        countryCode: nullable(t.string),
        postcode: nullable(t.string),
        city: nullable(t.string),
        date: nullable(t.string),
        time: nullable(t.string),
        openingTime: nullable(t.string),
        place: nullable(t.string),
    });
    const cargoViewBaseT = t.strict({
        id: t.string,
        description: nullable(t.string),
        type: cargoTypeT,
        color: nullable(t.union([t.literal("YELLOW"), t.literal("GREEN")])),
        createdAt: dateTime,
        cargoTagId: nullable(t.string),
        note: nullable(t.string),
        length: nullable(decimal),
        height: nullable(decimal),
        width: nullable(decimal),
        totalLm: decimal,
        totalWeight: nullable(decimal),
        assignedTeamId: t.string,
        assignedRouteId: nullable(t.string),
        clientId: nullable(t.string),
        smartMatch: t.boolean,
        firstStop: cargoViewStopT,
        lastStop: nullable(cargoViewStopT),
        deleted: t.boolean,
        invoiceable: optional(t.boolean),
        invoiced: optional(t.boolean),
        invoiceRef: nullable(t.string),
        cargoRef: nullable(t.string),
        allStopsDeparted: t.boolean,
        firstStopArrived: t.boolean,
        qualities: t.array(t.string),
        requirements: t.array(t.string),
        hideForDrivers: t.boolean,
        splitFromCargoId: nullable(t.string),
        originalRouteIdBeforeSplit: nullable(t.string),
        hasBeenSplit: t.boolean,
        operationInProgress: withFallback(t.boolean, false),
    });
    const cargoViewT = t.intersection([
        cargoViewBaseT,
        t.exact(t.partial({
            deletedBy: nullable(t.string),
            deletedByDriver: nullable(t.string),
        })),
    ]);
    const cargoViewsT = t.array(cargoViewT);
    return { cargoViewStopT, cargoViewT, cargoViewsT };
};
//# sourceMappingURL=cargo-view.js.map